const BILLING_DETAILS_KEY = 'billingDetails';
const INVOICES_KEY = 'invoices';
const VAT_TYPES_KEY = 'vatTypes';
const BASKETS_KEY = 'baskets';
export const getBillingDetailsKey = () => [BILLING_DETAILS_KEY];
export const getInvoicesKey = () => [INVOICES_KEY];
export const getVatTypesKey = () => [VAT_TYPES_KEY];
export const getBasketsKey = (args) => args ? [BASKETS_KEY, args] : [BASKETS_KEY];
//# sourceMappingURL=billing.js.map